<template>
  <div>

    <v-toolbar scroll-off-screen app v-if="$vuetify.breakpoint.xsOnly" class="mobile-toolbar">
      <v-toolbar-side-icon @click.stop="mini=false; drawer=!drawer">
        <v-icon>far fa-bars</v-icon>
      </v-toolbar-side-icon>

      <v-toolbar-title><img class="logo invert" alt="" :src="logo"> {{title}}</v-toolbar-title>

      <v-spacer></v-spacer>
    </v-toolbar>

    <v-navigation-drawer
      dark
      persistent
      :value="$vuetify.breakpoint.smAndUp || drawer"
      @input="drawer = $event"
      enable-resize-watcher
      :app="true || !($vuetify.breakpoint.smOnly && !mini)"
      :stateless="!$vuetify.breakpoint.xsOnly || mini"
      :temporary="$vuetify.breakpoint.xsOnly && drawer"
      :absolute="($vuetify.breakpoint.xsOnly || ($vuetify.breakpoint.smOnly && !mini)) && false"
      :mini-variant="mini && !$vuetify.breakpoint.xsOnly"
      fixed
    >

      <v-toolbar flat>
        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-tooltip right>
                <v-btn
                  flat
                  icon
                  @click.stop="
                    if (!$vuetify.breakpoint.xsOnly) mini=!mini;
                    else drawer = !drawer;
                  "
                  slot="activator"
                >
                  <v-icon>far fa-bars</v-icon>
                </v-btn>
                <span>{{mini ? 'Open' : 'Close'}} Menu</span>
              </v-tooltip>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="title">
                <img class="logo" alt="" :src="logo"> {{title}}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn
                flat icon
                @click.stop="
                  if (!$vuetify.breakpoint.xsOnly) mini=!mini;
                  else drawer = !drawer;
                "
              >
                <v-icon>fas fa-chevron-left</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <v-list dark class="nav-items">
        <v-list-group>
          <v-list-tile slot="activator">
            <v-list-tile-action>
              <v-tooltip right>
                <v-icon slot="activator">far fa-user-circle</v-icon>
                <span>{{user.name}}</span>
              </v-tooltip>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{user.name}}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile to="/logout">
            <v-list-tile-action>
              <v-tooltip right>
                <v-icon slot="activator">far fa-sign-out</v-icon>
                <span>Logout</span>
              </v-tooltip>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Logout
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <profile/>

        </v-list-group>

        <v-divider dark/>

        <v-list-tile
          v-for="(item, i) in items"
          :key="i"
          :to="item.link"
          :value="$route.path === item.link"
          :color="$route.path === item.link ? 'primary' : 'default'"
        >
          <v-list-tile-action>
            <v-tooltip right>
              <v-icon v-html="item.icon" slot="activator"/>
              <span>{{item.name}}</span>
            </v-tooltip>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{item.name}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>
    </v-navigation-drawer>
    <v-dialog
      :value="typeof $route.query.heuristic !== 'undefined'"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <heuristic />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
import heuristic from './heuristic/index.vue';
import profile from './profile.vue';

export default {
  components: {
    heuristic,
    profile,
  },
  data() {
    return {
      drawer: false,
      clipped: false,
      mini: true,
      right: null,
      title: '',
      logo: `${process.env.BASE_URL}img/logo.png`,
    };
  },
  computed: {
    ...mapGetters('users', { currentUser: 'current' }),
    user() {
      return (this.currentUser._id === this.$store.state.auth.payload.userId
        ? this.currentUser
        : this.$store.state.auth.user) || { profile: {} };
    },
    items() {
      const items = [{
        icon: 'far fa-chart-line',
        name: 'Results',
        link: '/',
      },
      {
        icon: 'far fa-history',
        name: 'History',
        link: '/history',
      },
      {
        icon: 'far fa-info-circle',
        name: 'Heuristic',
        link: '?heuristic',
      }];
      if (this.user.perm === 'student') {
        items.splice(1, 0, {
          icon: 'far fa-tooth',
          name: 'Clinic',
          link: '/clinic',
        });
      }
      if (this.user.perm === 'admin') {
        items.splice(1, 0, {
          icon: 'far fa-cog',
          name: 'Admin',
          link: '/admin',
        });
      }
      if (this.user.perm !== 'student') {
        items.splice(1, 0, {
          icon: 'far fa-ballot-check',
          name: 'Grading',
          link: '/grading',
        });
      }
      return items;
    },
  },
  methods: {
    ...mapActions('auth', { logoutUser: 'logout' }),
    async logout() {
      Object.keys(store._mutations).forEach((key) => {
        if (key.indexOf('/clearAll') !== -1) store.commit(key);
      });
      await this.logoutUser();
      this.$router.push({ path: '/login' });
    },
  },
};
</script>

<style lang="stylus" scoped>
div >>> .v-navigation-drawer
  background -moz-linear-gradient(-45deg, #6791bf 0%, #796bb2 100%)
  background -webkit-linear-gradient(-45deg, #6791bf 0%,#796bb2 100%)
  background linear-gradient(135deg, #6791bf 0%,#796bb2 100%)
  .v-list
    background transparent
  .nav-items .v-list__tile
      padding-left 30px
  .primary--text
    color rgba(255, 255, 255, 0.7)!important
  .v-divider
    border-color rgba(255, 255, 255, 0.5)!important
  .v-list__group__header__append-icon
    margin-right: 14px

div >>> .v-navigation-drawer--mini-variant
  .v-list__group__header__append-icon
    display none
  .nav-items .v-list__tile
      padding-left 16px

div >>> .v-toolbar:not(.mobile-toolbar)
  background transparent
div >>> .v-toolbar.mobile-toolbar
  width 100vw

.logo
  height 1.2em
.logo.invert
  height 1.6em
  -webkit-filter invert(1)
  filter invert(1)
</style>
